// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/run-up-procedures.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/run-up-procedures/run-up-procedures.js';

mount([g0]);
